import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import SchedulePage from './pages/SchedulePage';
import UserManagementPage from './pages/UserManagementPage';
import FileUploadPage from './pages/FileUploadPage';
import NotFoundPage from './pages/NotFoundPage';
import AuthScreen from './components/AuthScreen';
import { useAuth } from './hooks/useAuth';

const App: React.FC = () => {
  const { isAuthenticated, isLoading, user, login, logout } = useAuth();

  // Show loading screen while checking authentication
  if (isLoading) {
    return (
      <div className="app loading">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>システムを読み込み中...</p>
        </div>
      </div>
    );
  }

  // Show login screen if not authenticated
  if (!isAuthenticated) {
    return <AuthScreen onLogin={login} />;
  }

  return (
    <ErrorBoundary>
      <div className="app">
        <Navigation 
          user={user}
          onLogout={logout}
        />
        
        <main className="main-content">
          <Routes>
            {/* Protected Routes */}
            <Route 
              path="/" 
              element={
                <ProtectedRoute>
                  <SchedulePage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/users" 
              element={
                <ProtectedRoute>
                  <UserManagementPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/upload" 
              element={
                <ProtectedRoute>
                  <FileUploadPage />
                </ProtectedRoute>
              } 
            />
            
            {/* 404 Not Found */}
            <Route path="/404" element={<NotFoundPage />} />
            
            {/* Redirect any unknown routes to 404 */}
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </main>
      </div>
    </ErrorBoundary>
  );
};

export default App;